export const AIDA_ASSISTANT_NAME = 'SalesPostCallCoachingAgent';
